import React, { useEffect, useState } from "react";
import { Table, Input, Button, Select } from "antd";
import { ReactComponent as ExcelDownIcon } from "../../../../../assets/icon/ExcelDown.svg";
import { ReactComponent as ImgDownIcon } from "../../../../../assets/icon/imageDown.svg";
import { ReactComponent as DownloadIcon } from "../../../../../assets/icon/下载.svg";
import { ReactComponent as LotusIcon } from "../../../../../assets/icon/expressionAnay/Lotus.svg";
import http from "../../../../../utils/http";
import ExpressionIStyel from "./expressionI.module.css";
import styled from "styled-components";

import { optionsArr, AnaSelectOptions } from "./select";

const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;

function ExpressionI() {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [PageSize, setPageSize] = useState(10);
  const [TableDataOne, setTableDataOne] = useState([]);
  const [searchText, setSearchText] = useState({});
  const [selectVal, setSelectVal] = useState("P21");

  useEffect(() => {
    const { gene_id, sample, variety, tissue, time } = searchText;
    GetExpressionList(
      page,
      PageSize,
      variety,
      sample,
      gene_id,
      tissue,
      time,
      selectVal
    );
  }, [page, PageSize, searchText, selectVal]);

  const GetExpressionList = (
    pages,
    page_size,
    variety,
    sample,
    gene_id,
    tissue,
    time,
    project
  ) => {
    http
      .get(
        `/api/trans/expression/?page=${pages}&page_size=${page_size}&variety=${
          variety || ""
        }&sample=${sample || ""}&gene_id=${gene_id || ""}&tissue=${
          tissue || ""
        }&time=${time || ""}&project=${project}`
      )
      .then((res) => {
        setTotal(res.count);
        setTableDataOne(res.results);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // 分页配置
  const paginationConfig = {
    current: page,
    pageSize: PageSize,
    total: total,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    onChange: (page) => {
      setPage(page);
    },
    onShowSizeChange: (current, size) => {
      setPageSize(size);
      setPage(1); // Reset to first page on page size change
    },
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm(); // 关闭筛选下拉框
    const updatedSearchText = { ...searchText, [dataIndex]: selectedKeys[0] }; // 更新搜索条件
    setSearchText(updatedSearchText);
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    const updatedSearchText = { ...searchText };
    delete updatedSearchText[dataIndex]; // 移除该字段的搜索条件
    setSearchText(updatedSearchText);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <span
        style={{
          color: filtered ? "#1890ff" : undefined,
          cursor: "pointer",
        }}
      >
        🔍
      </span>
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
  });

  const Expression_colums = [
    {
      key: "1",
      title: "Gene ID",
      dataIndex: "gene_id",
      align: "center",
      ...getColumnSearchProps("gene_id"),
    },
    {
      key: "2",
      title: "Sample",
      dataIndex: "sample",
      align: "center",
      ...getColumnSearchProps("sample"),
    },
    {
      key: "3",
      title: "Variety",
      dataIndex: "variety",
      align: "center",
      ...getColumnSearchProps("variety"),
    },
    {
      key: "4",
      title: "Tissue",
      dataIndex: "tissue",
      align: "center",
      ...getColumnSearchProps("tissue"),
    },
    {
      key: "5",
      title: "Time",
      dataIndex: "time",
      align: "center",
      ...getColumnSearchProps("time"),
    },
    {
      key: "6",
      title: "FPKM",
      dataIndex: "fpkm",
      align: "center",
    },
    {
      key: "7",
      title: "TPM",
      dataIndex: "tpm",
      align: "center",
    },
  ];
  function downloadCSV(csvString, filename) {
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename || "data.csv"; // 设置文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  function convertToCSV(jsonData) {
    if (!jsonData || jsonData.length === 0) {
      return "";
    }

    const columns = Object.keys(jsonData[0]);
    let csvString = columns.join(",") + "\n";

    jsonData.forEach((row) => {
      let rowString = columns
        .map((column) => {
          let value = row[column];
          if (
            typeof value === "string" &&
            (value.includes(",") || value.includes("\n") || value.includes('"'))
          ) {
            value = `"${value.replace(/"/g, '""')}"`; // 替换双引号为两个双引号
          }
          return value;
        })
        .join(",");
      csvString += rowString + "\n";
    });

    return csvString;
  }
  const handleDownloadCSV = () => {
    if (TableDataOne.length === 0) {
      alert("No data to download");
      return;
    }
    console.log(AnaSelectOptions[selectVal]);
    // 从表单中获取 Genome 的值
    const genomeValue = AnaSelectOptions[selectVal];

    // 如果 Genome 值为空，使用默认文件名
    const filename = genomeValue ? `${genomeValue}.csv` : "table_data.csv";

    // 将表格数据转换为 CSV 字符串
    const csvString = convertToCSV(TableDataOne);

    // 触发文件下载
    downloadCSV(csvString, filename);
  };
  return (
    <div className={ExpressionIStyel.ExpAnaly_expression}>
      <div className={ExpressionIStyel.ExpAnaly_expression_title}>
        <p>1、Expression</p>
      </div>
      <img
        src={require("../../../../../assets/image/图片1.png")}
        style={{ width: "40%" }}
        alt=""
      />
      {/* <LotusIcon width={90}/> */}
      <div className={ExpressionIStyel.ExpAnaly_expression_content_form}>
        <Select
          defaultValue={["Transcriptome of Lotus Seed Cotyledon Development"]}
          style={{ width: "auto" }}
          options={optionsArr}
          onChange={(e) => {
            setSelectVal(e);
          }}
        />
        <Button
          onClick={handleDownloadCSV}
          style={{ border: "none", cursor: "pointer" }}
        >
          <DownloadIcon width={20} />
          CSV
        </Button>
      </div>
      <StyledTable
        bordered
        style={{ width: "100%" }}
        columns={Expression_colums}
        dataSource={TableDataOne}
        pagination={paginationConfig}
      />
 
    </div>
  );
}

export default ExpressionI;
